import React, { useState, useContext } from "react";
import { AuthContext } from "../App";
import { Button } from "./ui/button";
import { AlertTriangle } from "lucide-react";
import { SubscribeDialog } from "./demo/SubscribeDialog";

export default function BillingLocked() {
  const { logout } = useContext(AuthContext);
  const [subOpen, setSubOpen] = useState(false);
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4" data-testid="billing-locked-page">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-slate-800 flex items-center justify-center mx-auto">
          <AlertTriangle className="w-8 h-8 text-amber-400" />
        </div>
        <h1 className="text-2xl font-bold text-white mt-5">Your account is on hold</h1>
        <p className="text-slate-400 mt-3">
          We couldn't process your most recent payment and your grace period has ended.
          Update your payment details to restore access — your data is safe.
        </p>
        <Button onClick={() => setSubOpen(true)} className="mt-6 w-full h-12 text-base bg-amber-500 hover:bg-amber-600 font-semibold" data-testid="billing-locked-fix-btn">
          Update Payment & Restore Access
        </Button>
        <p className="text-sm text-slate-400 mt-6">Need help? Call Chris on 0410 344 600.</p>
        <button onClick={logout} className="text-slate-500 underline text-sm mt-6">Back to login</button>
      </div>
      <SubscribeDialog open={subOpen} onClose={() => setSubOpen(false)} />
    </div>
  );
}
